var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_1033)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_235_1033)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_235_1033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37128 1.7248L25.571 0.0911986C28.2974 -0.142401 28.9988 0.0140785 30.7121 1.25792L37.7985 6.23488C38.9678 7.09056 39.3575 7.32352 39.3575 8.25664V35.5533C39.3575 37.264 38.7338 38.2758 36.5534 38.4307L10.7729 39.9862C9.13608 40.0643 8.3572 39.831 7.49992 38.7414L2.28136 31.9763C1.34632 30.7306 0.95752 29.799 0.95752 28.7088V4.44576C0.95752 3.0464 1.58152 1.87968 3.37128 1.7248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57928 7.0128C8.82408 8.02368 9.29128 7.94656 11.6292 7.7904L33.6705 6.46816C34.138 6.46816 33.7492 6.00224 33.5934 5.9248L29.9326 3.28032C29.2314 2.73632 28.297 2.11296 26.506 2.26912L5.16328 3.82432C4.38504 3.90144 4.22952 4.29056 4.53928 4.60192L7.57928 7.0128ZM8.90248 12.1456V35.3197C8.90248 36.5651 9.52552 37.031 10.9271 36.9539L35.1505 35.5533C36.553 35.4765 36.7092 34.6198 36.7092 33.6077V10.5898C36.7092 9.57984 36.3204 9.03488 35.4618 9.11264L10.1482 10.5898C9.21384 10.6682 8.90248 11.135 8.90248 12.1456ZM32.8158 13.3888C32.971 14.0896 32.8158 14.7894 32.1134 14.8682L30.946 15.1005V32.209C29.9329 32.753 28.9982 33.0643 28.2196 33.0643C26.9729 33.0643 26.6609 32.6752 25.7268 31.5091L18.0926 19.5338V31.121L20.5086 31.6656C20.5086 31.6656 20.5086 33.0646 18.5594 33.0646L13.1863 33.376C13.0302 33.0646 13.1863 32.2877 13.7313 32.1318L15.1335 31.7437V16.423L13.1866 16.2672C13.0305 15.5664 13.4193 14.5565 14.5105 14.4781L20.2746 14.0896L28.2196 26.2218V15.4893L26.194 15.257C26.0385 14.4006 26.6609 13.7786 27.4398 13.7018L32.8158 13.3888ZM3.37128 1.7248L25.571 0.0911986C28.2974 -0.142401 28.9988 0.0140785 30.7121 1.25792L37.7985 6.23488C38.9678 7.09056 39.3575 7.32352 39.3575 8.25664V35.5533C39.3575 37.264 38.7338 38.2758 36.5534 38.4307L10.7729 39.9862C9.13608 40.0643 8.3572 39.831 7.49992 38.7414L2.28136 31.9763C1.34632 30.7306 0.95752 29.799 0.95752 28.7088V4.44576C0.95752 3.0464 1.58152 1.87968 3.37128 1.7248Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_1033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.157227)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_235_1033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.157227)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_235_1033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4,
    height: 40,
    fill: "white",
    transform: "translate(0.95752)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo3.aa779bdeb7d90a336e9f34801cee355d.svg";
export { ForwardRef as ReactComponent };